module.exports = __webpack_public_path__ + "static/media/flood-insurance-fc.721e9c2f.svg";